export const ADD_TO_CART = "ADD_TO_CART";
export const DECREMENT_QTY = "DECREMENT_QTY";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const REMOVE_ALL_FROM_CART = "REMOVE_ALL_FROM_CART";
export const ADJUST_CART_FOR_CHECKOUT = "ADJUST_CART_FOR_CHECKOUT";
export const SAVE_CART = "SAVE_CART";
var strings = require("../../translations/italian.json");
//add to cart

//adjust Cart For CheckOut
export const adjustCartForCheckOut = (item) => {

  return dispatch => {
    //console.log(item);
    dispatch({
      type: ADJUST_CART_FOR_CHECKOUT,
      payload: item
    });
  };
};

export const addToCart = (
  item,
  addToast,
  quantityCount,
  selectedProductColor,
  selectedProductSize,
  selectedIDArt,
  Ord1,
  Ord2,
  setQuantityCount
) => {

  return dispatch => {
    if (addToast) {
      const messaggio = (quantityCount && quantityCount > 1)
                      ? ' ' + strings.addeds_to_cart + ' ' + quantityCount + 'pz ' + (selectedProductSize || '') + ' - ' + (selectedProductColor?.split('-')?.[1] || '')
                      : strings.added_to_cart + ' ' + (selectedProductSize || '') + ' - ' + (selectedProductColor?.split('-')?.[1] || '');
      addToast(messaggio , { appearance: "success", autoDismiss: true });
    }

    if (setQuantityCount)
      {
        setQuantityCount(0);
      }

    //console.log(item)
    const itemToAdd = {...item,
      image: item.image,
      quantity: quantityCount,
      selectedProductColor: selectedProductColor
        ? selectedProductColor
        : item.selectedProductColor
        ? item.selectedProductColor
        : null,
      selectedProductSize: selectedProductSize
        ? selectedProductSize
        : item.selectedProductSize
        ? item.selectedProductSize
        : null,
      selectedIDArt: selectedIDArt
        ? selectedIDArt
        : item.selectedIDArt
        ? item.selectedIDArt
        : item.id,
        ord1: Ord1,
        ord2: Ord2};
    //console.log(itemToAdd);
    dispatch({
      type: ADD_TO_CART,
      payload: {
        ...itemToAdd
      }
    });
  };
};


//decrement from cart
export const decrementQty = (item, addToast) => {
  return dispatch => {
    if (addToast) {
      addToast("Quantià decrementate", {
        appearance: "warning",
        autoDismiss: true
      });
    }
    dispatch({ type: DECREMENT_QTY, payload: item });
  };
};

//remove from cart
export const removeFromCart = (item, addToast) => {
  return dispatch => {
    if (addToast) {
      addToast("Articolo rimosso dal carrello", { appearance: "error", autoDismiss: true });
    }
    dispatch({ type: REMOVE_FROM_CART, payload: item });
  };
};

//remove all from cart
export const removeAllFromCart = addToast => {
  return dispatch => {
    if (addToast) {
      addToast("Il carrello è stato svuotato", {
        appearance: "error",
        autoDismiss: true
      });
    }
    dispatch({ type: REMOVE_ALL_FROM_CART });
  };
};

// get stock of cart item
export const cartItemStock = (item, color, size) => {
  //console.log(item);
  if (item.stock || item.variation.length == 0) {
    return item.stock;
  } else {
    return item.variation
      .filter(single => single.color === color)[0]
      .size.filter(single => single.name === size)[0].stock;
  }
};
